import { useRef } from "react";
import { useQuery } from "react-query";
import openhouseAPI from "../services/openhouse";

export const useGetOpenHouseDetails = (uuid: string) => {
  const lastFetchedRef = useRef<number | null>(null);

  const query = useQuery(
    ["openHouseDetails", uuid],
    async () => {
      const response = await openhouseAPI.get(
        `/openhouse/${uuid}/attendeesAndTags`
      );
      lastFetchedRef.current = Date.now();
      return response.data.data;
    },
    {
      enabled: true,
      staleTime: 3000,
      cacheTime: 3000,
    }
  );

  const safeRefetch = async () => {
    const now = Date.now();
    if (!lastFetchedRef.current || now - lastFetchedRef.current > 3000) {
      return query.refetch();
    } else {
      return query;
    }
  };

  return {
    ...query,
    refetch: safeRefetch,
  };
};
